module.exports = __webpack_public_path__ + "img/box-02.3188aa81.svg";